import { Header } from "@/components/SiteUI";
import tests from "@/shared/api/tests";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { SMIResults } from "./results/SMIResults";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { default as SMIQuestions } from "./data/smi";
import { default as YoungQuestions } from "./data/young";
import { default as BeckQuestions } from "./data/beck";
import { YoungResults } from "./results/YoungResults";
import { format } from "date-fns";
import { BeckResults } from "./results/BeckResults";

const SMI_ANSWERS = {
    SMI: {
        1: "Никогда или почти никогда",
        2: "Редко",
        3: "Иногда",
        4: "Часто",
        5: "Почти всегда",
        6: "Всегда",
    },
    Young: {
        1: "Абсолютно не соответствует",
        2: "По большей части не соответствует",
        3: "Скорее не соответствует, чем соответствует",
        4: "Скорее соответствует",
        5: "По большей части соответствует",
        6: "Полностью соответствует",
    }

}

export const ResultPage = () => {
    const { id } = useParams();

    const [results, setResults] = useState(null);

    const fetchResults = async () => {
        try {
            const res = await tests.getResults(id);
            setResults(res.data);
        } catch (err) {
            console.error(err.message);
        }
    }

    useEffect(() => {
        if (!id) return;
        fetchResults().catch(console.error);
    }, [id])

    const ResultRender = () => {
        if (!results) return null;
        switch (results.type) {
            case 'SMI':
                return <SMIResults scores={results.results} />
            case 'Young':
                return <YoungResults scores={results.results} />
            case 'Beck':
                return <BeckResults scores={results.results} />
            default:
                return null;
        }
    }

    const isChecked = (id, i) => {
        return new Map(Object.entries(results?.results[i])).has(String(id));
    }

    const QuestionRender = () => {
        switch (results.type) {
            case "SMI":
                return <div className="flex flex-col gap-2">
                    {results.results.map((el, i) => (
                        <div key={i} className="flex flex-col">
                            <div><b>{i + 1}.</b> {SMIQuestions[i].question}</div>
                            <div><b>Ответ: <i>{SMI_ANSWERS[results.type][el]}</i></b></div>
                        </div>
                    ))}
                </div>
            case "Young":
                return <div className="flex flex-col gap-2">
                    {results.results.map((el, i) => (
                        <div key={i} className="flex flex-col">
                            <div><b>{i + 1}.</b> {YoungQuestions[i].question}</div>
                            <div><b>Ответ: <i>{SMI_ANSWERS[results.type][el]}</i></b></div>
                        </div>
                    ))}
                </div>
            case "Beck":
                return <div className="flex flex-col gap-2">
                    {results.results.map((el, i) => (
                        <div key={i} className="flex flex-col">
                            <div><b>{i + 1}.</b> {BeckQuestions[i].question}</div>
                            {BeckQuestions[i].answers.map((item) => (
                                <div key={item.id} className="flex flex-col">
                                    <div>
                                        <input
                                            type="checkbox"
                                            disabled={true}
                                            id={`answer-${i}`}
                                            checked={
                                                isChecked(item.id, i)
                                            }
                                            className="checkbox mr-2 w-4 h-4"
                                        />
                                        {isChecked(item.id, i) ? <b>{item.answer}</b> : item.answer}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
        }

    }

    if (!results?._id) return null;

    return (
        <div className="min-h-screen px-4 sm:px-8 py-8 bg-olive-50">
            <Header />
            <h2 className="text-center mt-24">Результаты теста</h2>

            <div className="bg-card rounded-lg border p-6">
                <div className="text-muted-foreground mb-4">Результаты теста пользователя: <b>{results.user.name}</b> за {format(results.createdAt, 'dd.MM.yyyy HH:mm')}</div>
                <Tabs defaultValue="results" className="w-full">
                    <TabsList className="mb-6">
                        <TabsTrigger value="results">Результаты</TabsTrigger>
                        <TabsTrigger value="questions">Вопросы</TabsTrigger>
                    </TabsList>

                    <TabsContent value="results">
                        <ResultRender />
                    </TabsContent>

                    <TabsContent value="questions">
                        <QuestionRender />
                    </TabsContent>
                </Tabs>
            </div>
        </div>
    )
}